"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = exports.InfoContainer = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n"])), (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('width'));
const InfoContainer = exports.InfoContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    align-items: center\n    display: flex;\n    justify-content: center;\n    width: 100%;\n"])));
const Progress = exports.Progress = _styledComponents.default.progress.withConfig({
  shouldForwardProp: prop => !['error', 'success'].includes(prop)
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    -webkit-appearance: none;\n    appearance: none;\n\n    ::-webkit-progress-bar {\n        background-color: #FFFFFF;\n        border: 1px solid ", ";\n        padding: 1px;\n    }\n\n    ::-webkit-progress-value {\n        background-color: ", ";\n        ", ";\n        ", ";\n        transition: all 300ms ease;\n    }\n\n    width: 100%;\n"])), (0, _Utils.getTheme)('primaryColor'), (0, _Utils.getTheme)('primaryColor'), _ref => {
  let {
    error,
    theme: {
      dangerColor
    }
  } = _ref;
  return !!error ? "background-color: ".concat(dangerColor, ";") : '';
}, _ref2 => {
  let {
    success,
    theme: {
      successColor
    }
  } = _ref2;
  return !!success ? "background-color: ".concat(successColor, ";") : '';
});